import { render, staticRenderFns } from "./updateForm.vue?vue&type=template&id=bb574f72&"
import script from "./updateForm.vue?vue&type=script&lang=js&"
export * from "./updateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports